// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"0c3c896f","732":"ca8710d0","977":"d25fd97c"}[chunkId] + ".chunk.js");